module.exports = __webpack_public_path__ + "static/media/csharp.b929c0b6.png";